import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=21882765&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./css/userInfo.styl?vue&type=style&index=0&id=21882765&prod&lang=stylus&scoped=true&external"
import style1 from "./css/userInfo_en.styl?vue&type=style&index=1&id=21882765&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21882765",
  null
  
)

export default component.exports